module.exports = __webpack_public_path__ + "static/media/icon-email.78fb0fc7.webp";